var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6c0-1.658 1.342-3 3-3h12c1.658 0 3 1.342 3 3v12c0 1.658-1.342 3-3 3H6c-1.658 0-3-1.342-3-3V6zm3-5C3.238 1 1 3.238 1 6v12c0 2.762 2.238 5 5 5h12c2.762 0 5-2.238 5-5V6c0-2.762-2.238-5-5-5H6zm1.5 7a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H13v7a1 1 0 1 1-2 0V9H8.5a1 1 0 0 1-1-1z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.80cde0ea3d2c08f72d01844f879277f5.svg";
export { ForwardRef as ReactComponent };